import { readConfig, e } from '@bayerntek/config/src'

export type Config = ReturnType<typeof get_config>
export const get_config = () =>
  readConfig(
    {
      app_version: e(String, '0-dev'),
      site_key: e(String, '0x4AAAAAABkeXf4XTiyZZBNQ'),
      app_name: e(String),
      is_auth_enabled: e(Boolean, true),
      is_multitab: e(Boolean, false),
      company: {
        name: e(String, 'SmartBot Solutions'),
        domain: e(String, 'localhost'),
      },
      footer: {
        prefix: '🇮🇳 Made in India',
      },
      identity: {
        api: e(String),
      },
      platform: {
        api: e(String),
      },
      graphql: {
        api: e(String),
      },
      assistant: {
        api: e(String, '/api/assistant'),
        ws: e(String, '/ws'),
      },
    } as const,
    'VITE',
  )
